import { render, staticRenderFns } from "./EditSourceDialog.vue?vue&type=template&id=867499bc"
import script from "./EditSourceDialog.vue?vue&type=script&lang=js"
export * from "./EditSourceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports